import { defineComponent as _defineComponent } from 'vue'
import router from "@/router";
// import { Toast } from "vant";
import { onMounted, ref } from "vue";
// import Live from "@/components/player/Live.vue";
import Storage from "@/uitls/Storage";
import { encryptionSearchShow, encryptionHomeSearchData } from "@/api/php/home"
// import SeachAll from "@/components/home/SeachAll.vue"
// import SeachLive from "@/components/home/SeachLive.vue"
// import SeachZb from "@/components/home/SeachZb.vue"
// import SeachMatch from "@/components/home/SeachMatch.vue"
import MatchCell from "@/components/home/MatchCell.vue"
import { uitlsToLiveRoom } from "@/uitls/uitls";

import { YMPush } from "@/uitls/uitls";


export default /*#__PURE__*/_defineComponent({
  name: 'Search',
  setup(__props, { expose }) {
  expose();

const value = ref("")
const historyList = ref([])
// const searchData = ref()

const hotSearch = ref([]);

const searchList = ref([]); // 搜索比赛列表，无对应比赛为空列表
const hotList = ref([]); // 正在热播，默认4条，有搜索结果时为空列表
//有搜索结果没
const isData = ref(false);
const onCancel = () => router.back();
// const active = ref(0);
// const primaryColor = process.env.VUE_APP_PRIMARY_COLOR as string;

onMounted(() => {
  YMPush('MAIN', 'SearchDialog');
  // getSearchHistory();
  getHotSearch();
});
//获取搜索记录
// const getSearchHistory = () => {
//   const history = Storage.get('searchHistory')
//   if (history) {
//     historyList.value = history;
//   }
// }

// 获取大家都在搜索
const getHotSearch = async () => {
  const ret: any = await encryptionSearchShow({});
  if (ret.code == 200 && ret.data.length > 0) {
    hotSearch.value = ret.data;
  }
}

//去搜索
const onSearch = async (val, isSetHistory = true) => {
  if (val == "") {
    return;
  }

  if (isSetHistory) {
    historyList.value.push(val)
    Storage.set('searchHistory', historyList.value)
  } else {
    value.value = val;
  }

  //搜索赛程
  const ret: any = await encryptionHomeSearchData({ content: val });
  if (ret.code == 200 && ret.data) {
    isData.value = true
    searchList.value = ret.data.search_list;
    hotList.value = ret.data.hot_list;
  }
};

// const clearHistory = () => {
//   Storage.set('searchHistory', [])
//   historyList.value = [];
//   Toast.success("删除成功")
// }


const __returned__ = { value, historyList, hotSearch, searchList, hotList, isData, onCancel, getHotSearch, onSearch, router, MatchCell, uitlsToLiveRoom }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})